module.exports = __webpack_public_path__ + "img/xls.a2340e14.png";